<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container :class="{ 'md-input-invalid': exam.fields.weight > 24 }">
          <label>Peso (kg)</label>
          <md-input
            id="weight"
            v-model="exam.fields.weight"
            v-validate="'required'"
            v-mask="weight"
            data-vv-validate-on="none"
            name="weight"
            title="Peso (kg)"
            placeholder="Peso (kg)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.weight"
            v-mask="weight"
            type="hidden"
          >
          <span
            v-if="exam.fields.weight > 24"
            class="md-error"
          >Insira um valor de até 24kg</span>
        </md-input-container>
        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>

    <div class="calc-card__result">
      <template>
        <p>
          Resultado lactose em pó:
          <strong>
            <span>{{ exam.result.powderedLactose || '0g' }}</span> de lactose diluidos em água*
          </strong>
        </p>
        <p>
          Resultado lactose líquida:
          <strong>
            <span>{{ exam.result.liquidLactose || '000ml' }}</span> de lactose*
          </strong>
        </p>
        <small> Crianças com peso igual ou superior a 25kg, administrar 50g de lactose. </small>
      </template>
    </div>
  </div>
</template>
<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'LactoseAbsorption',
  data: () => {
    return {
      exam: {
        fields: {
          weight: null
        },
        result: {
          powderedLactose: null,
          liquidLactose: null
        },
        error: false
      },
      weight: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 3,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 3
      })
    }
  },
  methods: {
    calculate() {
      if (this.exam.fields.weight < 25) {
        this.exam.error = false

        const weight = this.exam.fields.weight

        const powderedLactose = (2 * weight).toFixed(2)
        const liquidLactose = (12 * weight).toFixed(2)

        this.exam.result.powderedLactose = `${powderedLactose}g`
        this.exam.result.liquidLactose = `${liquidLactose}ml`
      } else {
        this.exam.error = true
      }
    }
  }
}
</script>